var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_333_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9766 0H0.0234375C0.0104933 0 0 0.0104933 0 0.0234375V79.9766C0 79.9895 0.0104933 80 0.0234375 80H79.9766C79.9895 80 80 79.9895 80 79.9766V0.0234375C80 0.0104933 79.9895 0 79.9766 0Z",
    fill: "#7289DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0625 61.25L50.7812 57.3438C57.1875 55.625 59.6875 51.25 59.6875 51.25C51.5625 58.9062 29.375 59.2188 20.7812 51.25C20.7812 51.25 22.9688 55.3125 29.5312 57.3438L25.9375 61.25C15 61.0938 10.7812 53.75 10.7812 53.75C10.7812 37.5 17.9688 24.5312 17.9688 24.5312C25.3125 19.375 32.0312 19.375 32.0312 19.375L32.5 20C23.4375 22.5 19.5312 26.5625 19.5312 26.5625C30.1562 19.375 52.0312 20 60.625 26.5625C60.7812 26.4062 55.4688 22.1875 47.1875 20L47.9688 19.375C47.9688 19.375 54.6875 19.375 62.0312 24.5312C62.0312 24.5312 69.2188 37.5 69.2188 53.75C69.2188 53.75 65 61.0938 54.0625 61.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 49.0625C33.4727 49.0625 35.7812 46.6141 35.7812 43.5938C35.7812 40.5734 33.4727 38.125 30.625 38.125C27.7773 38.125 25.4688 40.5734 25.4688 43.5938C25.4688 46.6141 27.7773 49.0625 30.625 49.0625Z",
    fill: "#7289DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75 49.0625C51.5977 49.0625 53.9062 46.6141 53.9062 43.5938C53.9062 40.5734 51.5977 38.125 48.75 38.125C45.9023 38.125 43.5938 40.5734 43.5938 43.5938C43.5938 46.6141 45.9023 49.0625 48.75 49.0625Z",
    fill: "#7289DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_333_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img-3.20710befe394098e73500d7003006624.svg";
export { ForwardRef as ReactComponent };